import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '@core';
import { MenuHeaderTopic } from '@ui';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import * as echarts from 'echarts';
import { filter, switchMap, tap } from 'rxjs';
import { CreateGroupBaselineComponent } from './create-group-baseline/create-group-baseline.component';
import { GroupBaselineService } from './data-access/group-baseline.service';
import { EditGroupBaselineComponent } from './edit-group-baseline/edit-group-baseline.component';
import { DatePipe } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { NativeDateAdapter } from '@angular/material/core';
export const MONTH_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === MONTH_FORMATS.display.dateInput) {
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${month.toString().padStart(2, '0')}/${year}`;
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}

export const DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class MonthDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${month.toString().padStart(2, '0')}/${year}`;
  }
}
@Component({
  selector: 'app-group-baseline',
  templateUrl: './group-baseline.component.html',
  styleUrls: ['./group-baseline.component.scss'],
  providers: [DatePipe],
})
export class GroupBaselineComponent implements OnInit, OnDestroy {
  meter: FormControl = new FormControl();
  formGroup = new FormGroup({
    start_time: new FormControl(null, Validators.required),
    end_time: new FormControl(null, Validators.required),
  });

  baseLineMenu: MenuHeaderTopic = {
    title: 'view_value.group_baseline',
    subtitle: 'view_value.group_detail',
    iconUrl: 'assets/shared/icons/baseline.svg',
  };

  parameterlist: { key: string; value: string }[] = [];
  mdblist: any[] = [];
  hours = Array.from({ length: 24 }, (_, i) => i);
  top_kwh_thismonth_options!: echarts.EChartsOption;
  all_mdb_today!: echarts.EChartsOption;
  all_mdb_today_series: echarts.EChartsOption = {};

  dialogRef!: MatDialogRef<any>;

  interval: any;

  date_select = new FormControl('date');

  constructor(
    private rest: GroupBaselineService,
    public dialog: MatDialog,
    public dialogService: DialogService,
    private datePipe: DatePipe,
    // private decimalPipe: DecimalPipe,
  ) {
    this.form_baseline_graph.valueChanges.subscribe({
      next: (value) => {
        this.loadBaselineGraph(value);
      },
    });
  }

  ngOnInit(): void {
    this.loadBaselineGroup(true).subscribe({
      next: () => {
        this.loadBaselineGraph(this.form_baseline_graph.value);
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.interval);
  }

  baseline_group_list: any[] = [];
  baseline_group_select: any;

  loadBaselineGroup(start?: boolean) {
    return this.rest.getBaselineGroup().pipe(
      tap((response) => {
        if (response.meta.response_code === 20000) {
          this.baseline_group_list = response.meta.response_data;

          if (start || this.baseline_group_list.length === 1) {
            this.baseline_group_select = this.baseline_group_list[0];

            this.form_baseline_graph.patchValue(
              {
                id: this.baseline_group_list[0].id,
                baseline_group_name: this.baseline_group_list[0].name,
              },
              { emitEvent: false },
            );
          }
        } else {
          alert('Occurred');
        }
      }),
    );
  }

  form_baseline_graph = new FormGroup({
    id: new FormControl(),
    baseline_group_name: new FormControl(),
    type: new FormControl('period'),
    period: new FormControl('month'),
    date: new FormControl(new Date()),
    month: new FormControl(new Date()),
  });

  mockup: any;

  baseline_overview_chartOptions!: echarts.EChartsOption;

  loadBaselineGraph(value: any) {
    const payload: any = {
      id: value.id,
      baseline_group_name: value.baseline_group_name,
      period: value.period,
    };

    if (value.period === 'day') {
      payload.date = this.datePipe.transform(value.date, 'yyyy-MM-dd');
    } else {
      payload.date = this.datePipe.transform(value.month, 'yyyy-MM');
    }

    this.dialogService
      .withLoading(this.rest.getBaselineGraph(payload))
      .subscribe({
        next: (response) => {
          if (response.meta.response_code == 20000) {
            this.mockup = response.meta.response_data;
            let value_graph = this.mockup;
            if (value_graph.detail.graph.day) {
              this.baseline_overview_chartOptions = this.createBarChart(
                value_graph.detail.baseline_group_name,
                {
                  data: value_graph.detail.graph.this,
                  markLine: this.baseline_group_select.setpoint_month
                    ? [
                        {
                          name: `${this.baseline_group_select.name}`,
                          value: this.baseline_group_select.setpoint_month,
                        },
                      ]
                    : [],
                },
                { name: 'Day', data: value_graph.detail.graph.day },
                { name: 'Value' },
                value_graph.data.export,
              );
            } else if (value_graph.detail.graph.hour) {
              this.baseline_overview_chartOptions = this.createBarChart(
                value_graph.detail.baseline_group_name,
                {
                  data: value_graph.detail.graph.this,
                  markLine: this.baseline_group_select.setpoint_day
                    ? [
                        {
                          name: `${this.baseline_group_select.name}`,
                          value: this.baseline_group_select.setpoint_day,
                        },
                      ]
                    : [],
                },
                { name: 'Hour', data: value_graph.detail.graph.hour },
                { name: 'Value' },
                value_graph.data.export,
              );
            }
            if (value_graph.detail.ranking) {
              let data: any[] = value_graph.detail.ranking;
              this.top_kwh_thismonth_options = this.createBarChartVerticalSort(
                data.map((value) => {
                  return {
                    ...value,
                    name: value.meter_name,
                    value: value.total_kwh,
                  };
                }),
                'kWh',
              );
            }
          } else {
            this.clearBaselineData();
          }
        },
        error: (e) => {
          console.error(e);
        },
      });
  }

  clearBaselineData() {
    this.mockup = null;
    this.baseline_overview_chartOptions = {};
    this.top_kwh_thismonth_options = {};
  }

  onMonthChange(date: Date) {
    this.form_baseline_graph.patchValue({
      month: date,
    });
  }

  selectBaseline(item: any) {
    this.form_baseline_graph.patchValue({
      id: item.id,
      baseline_group_name: item.name,
    });

    this.baseline_group_select = item;
  }

  primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--second-color')
    .trim();

  createBarChart(
    name: any,
    value: {
      data: any;
      markLine: any[];
    },
    xAxis: {
      name: string;
      data: any[];
    },
    yAxis: {
      name: string;
    },
    export_data: any[],
  ): echarts.EChartsOption {
    // return bar chart แบบแนวแบบนอนโดยใช้ข้อมูลแบบ Array

    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      toolbox: {
        show: true,
        feature: {
          magicType: { type: ['line', 'bar'] },
          dataView: {
            readOnly: true,
          },
          restore: {},
          saveAsImage: {
            type: 'png',
            name: 'Baseline',
          },
          myDowloadCsv: {
            show: true,
            title: 'Download CSV',
            icon: 'path://m 1.6214113,6.2377046 q -0.80063479,0 -1.21354076,-0.8172896 Q 0,4.6031254 0,3.2127937 0,2.2170155 0.17120492,1.5030614 0.34744527,0.77971308 0.70496142,0.39455361 1.0624776,0 1.6163758,0 1.8983604,0 2.1299906,0.0845472 2.3666562,0.15970027 2.5680737,0.29121814 V 1.1836608 Q 2.3666562,1.0333547 2.135026,0.95820162 1.9084313,0.87365442 1.6566593,0.87365442 q -0.6042526,0 -0.85602454,0.60122458 -0.2467365,0.6012245 -0.2467365,1.7379147 0,1.061537 0.27191369,1.6157909 0.27191365,0.5448598 0.84091825,0.5448598 0.2316302,0 0.4632604,-0.065759 0.2366656,-0.075153 0.4431186,-0.2254592 V 5.984063 Q 2.3716916,6.1061868 2.135026,6.1719457 1.9033958,6.2377046 1.6214113,6.2377046 Z m 2.3666546,0 q -0.6294299,0 -1.0121232,-0.3006122 V 5.0352556 q 0.2165239,0.1503061 0.4632604,0.2442474 0.2517719,0.093941 0.4985084,0.093941 0.3877288,0 0.5790754,-0.1690944 0.1963822,-0.1690944 0.1963822,-0.6763776 0,-0.3100065 -0.080567,-0.4978891 Q 4.552035,3.8422006 4.3657238,3.7106827 4.1794125,3.5697707 3.852109,3.4194646 3.3284234,3.165823 3.116935,2.7806635 2.9054466,2.3861099 2.9054466,1.7003382 q 0,-0.79850138 0.3121972,-1.24941979 Q 3.529841,0 4.1491999,0 4.4311845,0 4.677921,0.07515307 4.9296929,0.15030614 5.0706852,0.24424747 V 1.1460843 Q 4.6879919,0.87365442 4.2247315,0.87365442 q -0.3625516,0 -0.5639691,0.17848858 -0.2014176,0.1784885 -0.2014176,0.6481952 0,0.2724298 0.070496,0.4415242 0.070496,0.1690944 0.241701,0.2912182 0.1762404,0.1221237 0.4834021,0.2724299 0.3977997,0.1878826 0.6143236,0.4509184 0.2215593,0.2536416 0.3071617,0.6012245 0.090638,0.3381888 0.090638,0.770319 0,0.7985013 -0.3172326,1.2588138 Q 4.632602,6.2377046 3.9880659,6.2377046 Z M 6.6165641,6.1437633 5.3778462,0.09394134 H 5.9468507 L 6.9186904,5.0446497 7.8905301,0.09394134 H 8.4595347 L 7.2308876,6.1437633 Z',
            onclick: () => {
              this.onExportCSV(`Baseline Overview`, export_data);
            },
          },
        },
      },
      legend: {
        bottom: 0,
      },
      dataZoom: [
        {
          type: 'inside',
        },
      ],
      xAxis: [
        {
          type: 'category',
          name: xAxis.name,
          data: xAxis.data,
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: yAxis.name,
        },
      ],
      series: [
        {
          name: `${name}`,
          type: 'bar',
          data: value.data,
          label: {
            show: true,
            rotate: 90,
            position: 'top',
            verticalAlign: 'middle',
            distance: 40,
            align: 'center',
            formatter: (params: any) => {
              return (
                Number(params.value).toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                }) + ' kWh'
              );
            },
            fontSize: 12,
            color: `var(--second-color)`,
          },

          markLine: {
            symbol: 'none',
            data: value.markLine.map((v) => {
              return {
                name: v.name,
                yAxis: v.value,
                label: {
                  show: true,
                  formatter: '{b} : {c}',
                },
              };
            }),
          },
          itemStyle: {
            color: this.primaryColor,
            borderRadius: [10, 10, 0, 0],
          },
          // itemStyle: {
          //   color: function (params: any) {
          //     const colors = color_code;
          //     return colors[params.dataIndex % colors.length];
          //   }
          // },
        },
      ],
    };
  }

  createBarChartVerticalSort(
    value: {
      name: string;
      value: number | null;
      [key: string]: any;
    }[],
    name: string,
  ): echarts.EChartsOption {
    // return bar chart แบบแนวตั้งโดยใช้ข้อมูลแบบ Array และเรียงข้อมูล
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      toolbox: {
        show: true,
        feature: {
          dataView: {
            readOnly: true,
          },
          restore: {},
          saveAsImage: {
            type: 'png',
            name: 'Baseline',
          },
        },
      },
      grid: {
        top: '5%',
        bottom: '5%',
        containLabel: true,
      },
      dataZoom: [
        {
          type: 'inside',
        },
      ],
      xAxis: {
        type: 'value',
        axisLabel: {
          show: false,
        },
      },
      yAxis: {
        inverse: true,
        type: 'category',
        data: value.map((v: any) => `${v.name}`),
      },
      series: [
        {
          name: name,
          type: 'bar',
          realtimeSort: true,
          seriesLayoutBy: 'column',
          label: {
            show: true,
            position: 'right',
            formatter: (params: any) => {
              return (
                Number(params.value).toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                }) + ' kWh'
              );
            },
          },
          emphasis: {
            focus: 'series',
          },
          // data: value.map((v: any) =>
          //   this.decimalPipe.transform(v.value, '1.0-2'),
          // ),
          data: value.map((v: any) => v.value),
          barMaxWidth: 70,
          itemStyle: {
            color: this.primaryColor,
            borderRadius: [10, 10, 10, 10],
          },
        },
      ],
    };
  }

  onExportCSV(name: string, dataExport_csv: any) {
    try {
      let dataExport = dataExport_csv;
      let dataExport_0_value = dataExport[0];
      let headers = Object.keys(dataExport_0_value);
      var options = {
        showLabels: true,
        headers: headers,
        useHeader: true,
      };
      new AngularCsv(dataExport, `${name}`, options);
    } catch (error) {
      alert('Export Data Occurred');
    }
  }

  create_baseline() {
    this.dialog
      .open(CreateGroupBaselineComponent, {
        disableClose: true,
      })
      .afterClosed()
      .pipe(
        filter((value) => !!value),
        switchMap(() => this.loadBaselineGroup()),
      )
      .subscribe({
        next: () => {
          this.loadBaselineGraph(this.form_baseline_graph.value);
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  update_baseline(data: any) {
    this.dialog
      .open(EditGroupBaselineComponent, {
        disableClose: true,
        data: data,
      })
      .afterClosed()
      .pipe(
        filter((value) => value?.status),
        switchMap((value) => {
          this.baseline_group_select = value.value;

          this.form_baseline_graph.patchValue({
            baseline_group_name: value.value.name,
          });

          return this.loadBaselineGroup();
        }),
      )
      .subscribe({
        next: () => {
          this.loadBaselineGraph(this.form_baseline_graph.value);
        },
        error: (e) => {
          console.error(e);
        },
      });
  }

  delete_baseline(data: any) {
    this.dialogService
      .confirm({
        title: `ต้องการลบ Baseline "${data.name}" หรือไม่`,
      })
      .pipe(
        filter(Boolean),
        switchMap(() =>
          this.dialogService.withLoading(
            this.rest.deleteBaselineGroup(data.id),
          ),
        ),
      )
      .subscribe({
        next: (response) => {
          if (response.meta.response_code == 20000) {
            this.dialogService.success(`ลบข้อมูลสำเร็จ`);

            this.loadBaselineGroup().subscribe({
              next: () => {
                this.loadBaselineGraph(this.form_baseline_graph.value);
              },
              error: (e) => {
                console.error(e);
              },
            });
          } else {
            this.dialogService.error(`ลบข้อมูลไม่สำเร็จ`);
          }
        },
        error: (e) => {
          console.error(e);
        },
      });
  }
}
